export enum VisibilityTypeValues {
  PUBLIC = "PUBLIC",
  BD_ONLY = "BD_ONLY",
  BY_BUSINESS_UNIT = "BY_BUSINESS_UNIT",
  BY_USERS_GROUPS = "BY_USERS_GROUPS",
  DISABLED = "DISABLED",
}
